module.exports = __webpack_public_path__ + "static/kuveyt3-9b33b7c20e9750827e733aa4153294f3.png";